"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const ServiceImplBase_1 = require("./ServiceImplBase");
class ClientInfoServiceImpl extends ServiceImplBase_1.ServiceImplBase {
    get serviceName() {
        return "client-info-service" /* ClientInfo */;
    }
    getClientInfoAsync() {
        const verb = api_internal_contract_js_1.VerbId.GetEmbeddingClientInfo;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'getClientInfoAsync',
        };
        return this.execute(verb, parameters).then((response) => {
            const clientInfo = response.result;
            return clientInfo;
        });
    }
}
exports.ClientInfoServiceImpl = ClientInfoServiceImpl;
//# sourceMappingURL=ClientInfoServiceImpl.js.map